import styled from "styled-components";
import visa from "../img/visa.png";
import mastercard from "../img/mastercard.png";
import discover from "../img/discover.png";
import amex from "../img/amex.png";
import jcb from "../img/jcb.png";
import dinersclub from "../img/dinersclub.png";
import union from "../img/union.png";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  width: 222px;
  height: 135px;
  border-radius: 8px;
  background: linear-gradient(to left, #f2008c -20%, #673490 122%);
  margin: 5px auto 15px auto;
  position: relative;
  box-shadow: 0 0 15px #dcdcdc;
  overflow: hidden;

  @keyframes flipInY {
    from {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
      opacity: 0;
    }

    40% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
      transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
      -webkit-animation-timing-function: ease-in;
      animation-timing-function: ease-in;
    }

    60% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
      transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
      opacity: 1;
    }

    80% {
      -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
      transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
    }

    to {
      -webkit-transform: perspective(400px);
      transform: perspective(400px);
    }
  }

  &.flipInY {
    -webkit-backface-visibility: visible !important;
    backface-visibility: visible !important;
    -webkit-animation-name: flipInY;
    animation-name: flipInY;
  }

  &.animated {
    -webkit-animation-duration: 0.7s !important;
    animation-duration: 0.7s !important;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.tablet} {
    margin: 5px auto 15px auto;
  }

  ${mediaMaxWidth.smallTablet} {
    margin: 5px auto 30px auto;
  }
`;

interface IBrandProps {
  brand: string | boolean;
}

export const Brand = styled.div`
  display: ${(props: IBrandProps) =>
    props.brand !== false ? "block" : "none"};
  width: 38px;
  height: 23px;
  position: absolute;
  top: 97px;
  right: 20px;
  background-image: ${(props: IBrandProps) =>
    props.brand === "visa" && `url(${visa as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "jcb" && `url(${jcb as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "amex" && `url(${amex as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "unionpay" && `url(${union as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "diners" && `url(${dinersclub as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "discover" && `url(${discover as string})`};
  background-image: ${(props: IBrandProps) =>
    props.brand === "mastercard" && `url(${mastercard as string})`};
  background-size: contain;
  background-position-x: right;
  background-repeat: no-repeat;

  @keyframes bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity: 0;
      -webkit-transform: translate3d(3000px, 0, 0);
      transform: translate3d(3000px, 0, 0);
    }

    60% {
      opacity: 1;
      -webkit-transform: translate3d(-25px, 0, 0);
      transform: translate3d(-25px, 0, 0);
    }

    75% {
      -webkit-transform: translate3d(10px, 0, 0);
      transform: translate3d(10px, 0, 0);
    }

    90% {
      -webkit-transform: translate3d(-5px, 0, 0);
      transform: translate3d(-5px, 0, 0);
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  &.bounceInRight {
    -webkit-animation-name: bounceInRight;
    animation-name: bounceInRight;
  }

  &.animated {
    -webkit-animation-duration: 0.7s !important;
    animation-duration: 0.7s !important;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
`;

export const Chip = styled.img`
  width: 33px;
  position: absolute;
  top: 30px;
  left: 20px;
`;

export const Wave = styled.img`
  width: 16px;
  position: absolute;
  top: 32px;
  left: 67px;
`;

export const CardNumber = styled.div`
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  position: absolute;
  font-weight: 600;
  top: 67px;
  left: 20px;
`;

export const ExpiryDateLabel = styled.div`
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  position: absolute;
  top: 93px;
  left: 20px;
  font-size: 0.6em;
`;

export const ExpiryDate = styled.div`
  color: #fff;
  font-family: "Courier New", Courier, monospace;
  position: absolute;
  font-weight: 600;
  top: 106px;
  left: 20px;
  font-size: 0.8em;
`;

interface IGuideProps {
  cardNumberFocus?: boolean;
  expiryDateFocus?: boolean;
  cvcFocus?: boolean;
}

export const Guide = styled.div`
  opacity: 0;
  opacity: ${(props: IGuideProps) => props.cardNumberFocus && "1"};
  opacity: ${(props: IGuideProps) => props.expiryDateFocus && "1"};
  opacity: ${(props: IGuideProps) => props.cvcFocus && "1"};
  height: ${(props: IGuideProps) => props.cardNumberFocus && "24px"};
  height: ${(props: IGuideProps) => props.expiryDateFocus && "21px"};
  height: ${(props: IGuideProps) => props.cvcFocus && "31px"};
  width: ${(props: IGuideProps) => props.cardNumberFocus && "192px"};
  width: ${(props: IGuideProps) => props.expiryDateFocus && "48px"};
  width: ${(props: IGuideProps) => props.cvcFocus && "36px"};
  border: 2px solid #fcd144;
  border-radius: 4px;
  position: absolute;
  top: ${(props: IGuideProps) => props.cardNumberFocus && "65px"};
  top: ${(props: IGuideProps) => props.expiryDateFocus && "104px"};
  top: ${(props: IGuideProps) => props.cvcFocus && "54px"};
  left: ${(props: IGuideProps) => props.cardNumberFocus && "15px"};
  left: ${(props: IGuideProps) => props.expiryDateFocus && "15px"};
  left: ${(props: IGuideProps) => props.cvcFocus && "110px"};
  z-index: 1;
  transition: top 0.7s ease 0s, width 0.7s, height 0.7s,
    opacity 0.3s ease-in-out;
`;

export const Line = styled.div`
  background-color: #333;
  height: 30px;
  width: 100%;
  position: absolute;
  top: 20px;
`;

export const CvcWrapper = styled.div`
  background-color: #fff9eb;
  height: 23px;
  width: 150px;
  position: absolute;
  top: 58px;
  left: 10px;
`;

export const CvcNumbers = styled.div`
  position: absolute;
  top: 61px;
  left: 81px;
  font-size: 0.8em;
  color: #333;
  word-spacing: 5px;
  font-family: "Courier New", Courier, monospace;
`;
